import React from "react";
import { useTranslation } from "react-i18next";
import {
  Grid,
  Typography,
} from "@material-ui/core";
import { FlashOn } from "@material-ui/icons";
import { grey } from "@material-ui/core/colors";
import moment from "moment";

const DeviceUsageHistory = ({ events = [] }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid
        item
        xs={12}
        container
        spacing={2}
      >
        <Typography
          variant="h6"
          color="secondary"
          style={{
            padding: "30px 20px 10px 10px",
          }}
        >
          {t("use_notifications.history.title")}
        </Typography>
      </Grid>

      {events.length === 0 ? (
        <EmptyNotification t={t} />
      ) : (
        events.map((event, index) => (
          <UseEvent
            key={
              event?.event_datetime ??
              `${event?.event_id}-${index}`
            }
            date={event?.event_datetime}
            t={t}
          />
        ))
      )}
    </>
  );
};

const EmptyNotification = ({ t }) => (
  <Grid
    item
    xs={12}
    container
    alignItems="center"
  >
    <Typography
      variant="body1"
      color="textPrimary"
      style={{
        padding: "2px 20px 2px 4px",
      }}
    >
      {t("use_notifications.history.empty")}
    </Typography>
  </Grid>
);

const UseEvent = ({ date, t }) => (
  <Grid
    item
    xs={12}
    container
    alignItems="center"
  >
    <FlashOn
      style={{
        marginRight: 16,
        color: grey[600],
      }}
      fontSize="medium"
    />

    <Typography
      variant="body1"
      color="secondary"
      style={{
        padding: "2px 20px 2px 0px",
      }}
    >
      {t("use_notifications.item")}
    </Typography>

    <Typography
      variant="body1"
      color="textPrimary"
    >
      {date
        ? moment
            .utc(date)
            .local()
            .format("YYYY-MM-DD HH:mm:ss")
        : "-"}
    </Typography>
  </Grid>
);

export default DeviceUsageHistory;